import React, { useCallback, useEffect, useRef, useState } from "react"

import { filterObject } from "root/js/utils.js"

export default function useActiveDots(initial) {
	const [currentActiveDots, setCurrentActiveDots] = useState([])
	const dots = useRef({})
	const rechartsRef = useRef(null)
	const activeDotFactory = useCallback(
		(e, props = {}) => {
			if (!e.cy) return null; // фикс бага при котором показывались точки прерывающегося графика
			if (e.value === null || (Array.isArray(e.value) && e.value.includes(null))) return null
			dots.current = filterObject(dots.current, (key, value) => value.index === e.index)
			
			const key = e.key || e.dataKey
			const dotData = { ...e, key }
			dots.current[key] = dotData
			
			const isActive = currentActiveDots.find(item => item.key === key)
			return (
				<circle
					cx={e.cx}
					cy={e.cy}
					r={8}
					strokeWidth={4}
					stroke={e.fill}
					fill="white"
					strokeOpacity={isActive ? 1 : 0}
					fillOpacity={isActive ? 1 : 0}
					data-circle-id={key}
					{...props}
				/>
			)
		},
		[currentActiveDots]
	)
	useEffect(() => {
		let int
		let attachedNode = null

		const onMouse = e => {
			const x = e.clientX
			const y = e.clientY
			const radius = 16
			const node = e.currentTarget
			if (!node || !node.getBoundingClientRect) return null
			const { x: containerX, y: containerY } = node.getBoundingClientRect()
			const [realX, realY] = [x - containerX, y - containerY]
			const activeDots = Object.values(dots.current)
				.filter(
					item =>
						realX >= item.cx - radius &&
						realX <= item.cx + radius &&
						realY >= item.cy - radius &&
						realY <= item.cy + radius
				)
				.sort((a, b) => a.cy - b.cy)
				.slice(0, 5)
			setCurrentActiveDots(activeDots.length > 0 ? activeDots : [])
		}

		const getContainerNode = () => {
			if (!rechartsRef.current) return null
			if (rechartsRef.current.container) return rechartsRef.current.container
			if (rechartsRef.current.nodeType === 1) return rechartsRef.current
			return null
		}

		const addEvents = node => {
			node.addEventListener("mousemove", onMouse)
			node.addEventListener("click", onMouse)
			attachedNode = node
		}

		const node = getContainerNode()
		if (node) {
			addEvents(node)
		} else {
			int = setInterval(() => {
				const node = getContainerNode()
				if (node) {
					addEvents(node)
					clearInterval(int)
				}
			}, 1000)
		}

		return () => {
			clearInterval(int)
			if (attachedNode) {
				attachedNode.removeEventListener("mousemove", onMouse)
				attachedNode.removeEventListener("click", onMouse)
			}
		}
	}, [])

	return { rechartsRef, currentActiveDots, activeDotFactory }
}
